import './src/vaadin-avatar-group.js';
export * from './src/vaadin-avatar-group.js';
